<template>
    <BreadCrumb PageTitle="Liste des validations queue" />
    <ListeValidationQueue />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeValidationQueue from "@/components/ValidationQueue/ListeValidationQueue.vue";

export default defineComponent({
    name: "ListeValidationQueuePage",
    components: {
        BreadCrumb,
        ListeValidationQueue,
    },
});
</script>